export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 110,
    showHeaderOverflow: true,
    showOverflow: false,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_label_materialBatchNo') || '物料批次编号',
    field: 'materialBatchNo',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_materialBatchType') || '物料批次类型',
    field: 'materialBatchTypeText',
    headerAlign: 'center',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_materialBatchUnit') || '物料单位',
    field: 'materialBatchUnit',
    headerAlign: 'center',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_materialBatchName') || '批次物料名称',
    field: 'materialBatchName',
    headerAlign: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_materialBatchSpec') || '批次物料规格',
    field: 'materialBatchSpec',
    headerAlign: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_materialBatchDisplayName') || '物料显示名称',
    field: 'materialBatchDisplayName',
    headerAlign: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_ncNo') || 'NC物料编码',
    field: 'ncMaterialNo',
    headerAlign: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.table_label_order_no') || '订单编号',
    field: 'orderNo',
    headerAlign: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.table_label_production_order_goods_no') || '产品编号',
    field: 'orderGoodsNo',
    headerAlign: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.table_label_customer_name') || '客户名称',
    field: 'custName',
    headerAlign: 'center',
    minWidth: 160,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.table_label_production_order_scm_name') || '供应商名称',
    field: 'scmName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 160,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.quantity') || '数量',
    field: 'quantity',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: false,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_taxRate') || '税率',
    field: 'taxRate',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: false,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_unitPriceTaxIncluded') || '含税单价',
    field: 'unitPriceTaxIncluded',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: false,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_unitPrice') || '不含税单价',
    field: 'unitPrice',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: false,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_aoumntTaxIncluded') || '含税金额',
    field: 'aoumntTaxIncluded',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: false,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_aoumnt') || '不含税金额',
    field: 'aoumnt',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: false,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_hscode') || '海关编码',
    field: 'hscode',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_hsname') || 'hs品名',
    field: 'hsname',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.form_label_color') || '颜色',
    field: 'color',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.table_label_invInCtnQty') || '入数',
    field: 'inCtnQty',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: false,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
]
